module.exports = __webpack_public_path__ + "static/media/teams.8d6d422f.jpg";